import { type GetPromoResponse } from '@hungryroot/rest/api/get_promo_data/get';

type StaticPart = {
  type: 'static';
  text: string;
};

type EffectBase = {
  type: 'effect_base';
  text: string;
};

type PromoPart = StaticPart | EffectBase;

export function parsePromo(promoData: GetPromoResponse) {
  const { effect_str, effect_base } = promoData;

  const split = effect_str.split(effect_base);
  const parts: PromoPart[] = [];

  split.forEach((text, index) => {
    const shouldInsertEffectBase = index % 2 === 0;
    const trimmed = text.trim();
    const staticPart: StaticPart = {
      type: 'static',
      text: trimmed,
    };

    parts.push(staticPart);

    if (shouldInsertEffectBase === true) {
      parts.push({
        type: 'effect_base',
        text: effect_base,
      });
    }
  }, [] as PromoPart[]);

  return { parts };
}
